export enum MapKeyType {
  MasterKey = 'MasterKey',
  LocationList = 'LocationList',
}
